export const PLA_MARKET_STORE_LOCALIZED = 'PLA - Market Store Localized';
export const PLA_EXPERIENCE_EXPELLED = 'PLA - Experience Expelled';
export const SEARCH_TERM_NO_RESULT = 'Search Term No Result';
export const PLA_EXPERIENCE_LANDING = 'PLA - Experience Landed';
export const LAMINATE_COLOR_MISSING_IN_CLASSIFICATION =
  'Laminate color not found when switching classification';
export const IMAGE_MODAL_CLICKED = 'Image Modal Clicked';
export const VISUALIZATION_IMAGE_ERROR = 'Visualization Image Error';
export const IMAGE_ASSIST_INITIAL_RESPONSE = 'Image Assist - Initial Dimension Response';
export const IMAGE_ASSIST_RETRY_RESPONSE = 'Image Assist - Retry Dimension Response';
export const IMAGE_ASSIST_DIMENSIONS_APPLIED = 'Image Assist - Dimensions Applied';
export const IMAGE_ASSIST_GENERATE_MEASUREMENTS_CLICKED = 'Image Assist - Generate Measurements Clicked';
export const IMAGE_ASSIST_RETRY_CLICKED = 'Image Assist - Retry Clicked';
export const IMAGE_ASSIST_PANEL_OPENED = 'Image Assist - Panel Opened';
export const IMAGE_ASSIST_UPLOAD_SIZE_LIMIT_BLOCKED = 'Image Assist - Upload Size Limit Blocked';
export const DESIGN_SAVE_CONTINUE_INITIATED = 'DesignSaveContinueInitiated';
export const DESIGN_SAVE_CONTINUE_SHAPE_DETAIL = 'DesignSaveContinueShapeDetail';

export default async (actionName, actionObject) => {
  if (typeof window === 'undefined') return null;
  try {
    return window?.newrelic?.addPageAction(actionName, actionObject);
  } catch {
    return null;
  }
};
